"use client";

import "@splidejs/splide/dist/css/splide-core.min.css";

import { CallToActionParagraph } from "@/components/paragraphs/CallToActionParagraph";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface InternalApplicationProcessProps {
  locale: AllowedLanguages;
}

export const InternalApplicationProcess = ({
  locale,
}: InternalApplicationProcessProps) => {
  const { t } = useTranslation(locale);
  const data = {
    __typename: "ParagraphCallToAction" as const,
    id: "-1.internal-component-usage",
    status: true,
    title: t("internal.job.process.calltoaction.title"),
    paragraphCallToActionText: {
      processed: t("internal.job.process.calltoaction.text"),
    },
    paragraphCallToActionLink: {
      url: t("internal.job.process.calltoaction.link.url"),
      title: t("internal.job.process.calltoaction.link.text"),
      internal: true,
    },
    entity_type_behaviors: {
      background_color: "yellow",
    },
  };
  return (
    <>
      <CallToActionParagraph data={data} className="rounded" />
    </>
  );
};
